import { _get, _post } from "../../../../http";

// cuentas bancarias para el plantel
export const getCuentasBancariasPlantel = (plantelId) => _get(`/cuentaBancaria/planteles/${plantelId}`);

export const postCuentasBancariasPlantel = (plantelId, body) =>
  _post(`/cuentaBancaria/planteles/${plantelId}`, body);
